import { DataService } from './dataService'

const MarketplaceAdditionalService = {
	getMarketplaceadditionalcharges: async(data) => {
		return DataService.get('/admin/marketplace_additional_charges', data)
	},
	// addHscodeadditionalfees: async (data) => {
	// 	return DataService.post('/admin/hscode_additional_charges', data)
	// },
	updateMarketplaceadditionalcharges: async (data) => {
        return DataService.post('/admin/marketplace_additional_charges', data)
    },
}

export default MarketplaceAdditionalService